import React, { useState, useEffect, useRef } from "react";
import Icon from "./Icon";

export default function Tooltip({ text }) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);
  const containerRef = useRef(null);

  const showTooltip = () => {
    setVisible(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), 4000);
  };

  const hideTooltip = () => {
    setVisible(false);
    clearTimeout(timerRef.current);
  };

  const handleIconClick = () => {
    if (visible) {
      hideTooltip();
    } else {
      showTooltip();
    }
  };

  useEffect(() => {
    setVisible(true);
    timerRef.current = setTimeout(() => setVisible(false), 4000);

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        hideTooltip();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="tooltip-container"
    >
      <span onClick={handleIconClick} style={{ cursor: "pointer" }}>
        <Icon name="info" />
      </span>

      {visible && (
        <div className="tooltip-bubble">
          <div
            className="tooltip-text"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        </div>
      )}
    </div>
  );
}